import { default as _91_46_46_46slug_93XDjAndoEVYMeta } from "/home/runner/work/grove-web/grove-web/pages/[...slug].vue?macro=true";
import { default as _91slug_93LO4mCRzse4Meta } from "/home/runner/work/grove-web/grove-web/pages/blog/[slug].vue?macro=true";
import { default as indexSRAKe8nobwMeta } from "/home/runner/work/grove-web/grove-web/pages/index.vue?macro=true";
import { default as policiesgFtLBUNSzfMeta } from "/home/runner/work/grove-web/grove-web/pages/policies.vue?macro=true";
import { default as privacyG5tN4kYAAyMeta } from "/home/runner/work/grove-web/grove-web/pages/privacy.vue?macro=true";
import { default as referral_45termsOOxBPsQyfZMeta } from "/home/runner/work/grove-web/grove-web/pages/referral-terms.vue?macro=true";
import { default as sandbox6m9r37nkhuMeta } from "/home/runner/work/grove-web/grove-web/pages/sandbox.vue?macro=true";
import { default as termsfc5baMVZXXMeta } from "/home/runner/work/grove-web/grove-web/pages/terms.vue?macro=true";
export default [
  {
    name: _91_46_46_46slug_93XDjAndoEVYMeta?.name ?? "slug",
    path: _91_46_46_46slug_93XDjAndoEVYMeta?.path ?? "/:slug(.*)*",
    meta: _91_46_46_46slug_93XDjAndoEVYMeta || {},
    alias: _91_46_46_46slug_93XDjAndoEVYMeta?.alias || [],
    redirect: _91_46_46_46slug_93XDjAndoEVYMeta?.redirect,
    component: () => import("/home/runner/work/grove-web/grove-web/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93LO4mCRzse4Meta?.name ?? "blog-slug",
    path: _91slug_93LO4mCRzse4Meta?.path ?? "/blog/:slug()",
    meta: _91slug_93LO4mCRzse4Meta || {},
    alias: _91slug_93LO4mCRzse4Meta?.alias || [],
    redirect: _91slug_93LO4mCRzse4Meta?.redirect,
    component: () => import("/home/runner/work/grove-web/grove-web/pages/blog/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexSRAKe8nobwMeta?.name ?? "index",
    path: indexSRAKe8nobwMeta?.path ?? "/",
    meta: indexSRAKe8nobwMeta || {},
    alias: indexSRAKe8nobwMeta?.alias || [],
    redirect: indexSRAKe8nobwMeta?.redirect,
    component: () => import("/home/runner/work/grove-web/grove-web/pages/index.vue").then(m => m.default || m)
  },
  {
    name: policiesgFtLBUNSzfMeta?.name ?? "policies",
    path: policiesgFtLBUNSzfMeta?.path ?? "/policies",
    meta: policiesgFtLBUNSzfMeta || {},
    alias: policiesgFtLBUNSzfMeta?.alias || [],
    redirect: policiesgFtLBUNSzfMeta?.redirect,
    component: () => import("/home/runner/work/grove-web/grove-web/pages/policies.vue").then(m => m.default || m)
  },
  {
    name: privacyG5tN4kYAAyMeta?.name ?? "privacy",
    path: privacyG5tN4kYAAyMeta?.path ?? "/privacy",
    meta: privacyG5tN4kYAAyMeta || {},
    alias: privacyG5tN4kYAAyMeta?.alias || [],
    redirect: privacyG5tN4kYAAyMeta?.redirect,
    component: () => import("/home/runner/work/grove-web/grove-web/pages/privacy.vue").then(m => m.default || m)
  },
  {
    name: referral_45termsOOxBPsQyfZMeta?.name ?? "referral-terms",
    path: referral_45termsOOxBPsQyfZMeta?.path ?? "/referral-terms",
    meta: referral_45termsOOxBPsQyfZMeta || {},
    alias: referral_45termsOOxBPsQyfZMeta?.alias || [],
    redirect: referral_45termsOOxBPsQyfZMeta?.redirect,
    component: () => import("/home/runner/work/grove-web/grove-web/pages/referral-terms.vue").then(m => m.default || m)
  },
  {
    name: sandbox6m9r37nkhuMeta?.name ?? "sandbox",
    path: sandbox6m9r37nkhuMeta?.path ?? "/sandbox",
    meta: sandbox6m9r37nkhuMeta || {},
    alias: sandbox6m9r37nkhuMeta?.alias || [],
    redirect: sandbox6m9r37nkhuMeta?.redirect,
    component: () => import("/home/runner/work/grove-web/grove-web/pages/sandbox.vue").then(m => m.default || m)
  },
  {
    name: termsfc5baMVZXXMeta?.name ?? "terms",
    path: termsfc5baMVZXXMeta?.path ?? "/terms",
    meta: termsfc5baMVZXXMeta || {},
    alias: termsfc5baMVZXXMeta?.alias || [],
    redirect: termsfc5baMVZXXMeta?.redirect,
    component: () => import("/home/runner/work/grove-web/grove-web/pages/terms.vue").then(m => m.default || m)
  }
]